function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import '../../../common/utils/polyfills';
import React from 'react';
import { viewModeWrapper, utils } from 'pro-gallery-lib';
import Gallery from './galleryContainerNew.js';
import { GalleryComponent } from '../../galleryComponent';
import '../../../versionLogger';

var ProGallery = /*#__PURE__*/function (_GalleryComponent) {
  _inheritsLoose(ProGallery, _GalleryComponent);

  function ProGallery(props) {
    var _this;

    _this = _GalleryComponent.call(this) || this;

    _this.init(props);

    if (utils.isLocal() && !utils.isTest()) {
      console.log('PRO GALLERY DEV');
    }

    return _this;
  }

  var _proto = ProGallery.prototype;

  _proto.init = function init(props) {
    if (typeof props.viewMode !== 'undefined') {
      viewModeWrapper.setViewMode(props.viewMode);
    }

    if (typeof props.formFactor !== 'undefined') {
      viewModeWrapper.setFormFactor(props.formFactor);
    }
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.viewMode !== nextProps.viewMode) {
      utils.dumpCache();
      viewModeWrapper.setViewMode(nextProps.viewMode);
    }

    if (this.props.formFactor !== nextProps.formFactor) {
      utils.dumpCache();
      viewModeWrapper.setFormFactor(nextProps.formFactor);
    }
  };

  _proto.renderProps = function renderProps() {
    return _objectSpread(_objectSpread({}, this.props), {}, {
      domId: this.props.domId,
      items: this.props.items || [],
      watermarkData: this.props.watermarkData,
      settings: this.props.settings || {},
      offsetTop: this.props.offsetTop,
      itemsLoveData: this.props.itemsLoveData || {},
      proGalleryRegionLabel: this.props.proGalleryRegionLabel || 'Gallery. you can navigate the gallery with keyboard arrow keys.'
    });
  };

  _proto.containerProps = function containerProps() {
    return {
      id: "pro-gallery-" + this.props.domId,
      className: "pro-gallery"
    };
  };

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("div", this.containerProps(), /*#__PURE__*/React.createElement(Gallery, this.renderProps()));
  };

  return ProGallery;
}(GalleryComponent);

export { ProGallery as default };